import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  mealPlan: {
    currency: '',
    price_per_person: ''
  },
  listMealPlanInfo: [],
  MealPlanInfo: {},
  Currencies: [],
  Countrys: [],
  MealPlanPriceTotalPax: [],
  dataBank: {},
  dataInfoBankPax: {}
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
